import React from 'react';
import PropTypes from 'prop-types';

import StatContainer from '../StatContainer';
import Texts from '../../texts.json';

import {
  StatisticCard,
  StyledTitle,
  CountContainer,
} from './styles';
import texts from './texts.json';

const StatsCard = ({
  title,
  todayStats,
  monthlyStats,
  loading,
}) => {
  const isOnlineStatsCard = title === Texts.online;

  const { count, growth, isPositive } = todayStats;
  const { count: monthlyCount, growth: monthlyGrowth, isPositive: monthlyIsPositive } = monthlyStats;

  return (
    <StatisticCard>
      <StyledTitle>{title}</StyledTitle>
      <CountContainer>
        <StatContainer
          loading={loading}
          count={count}
          growth={growth}
          isPositive={isPositive}
          label={isOnlineStatsCard ? Texts.fromLastWeek : texts.today}
        />
        {!isOnlineStatsCard && (
          <StatContainer
            loading={loading}
            count={monthlyCount}
            growth={monthlyGrowth}
            isPositive={monthlyIsPositive}
            label={texts.thisMonth}
          />
        )}
      </CountContainer>
    </StatisticCard>
  );
};

StatsCard.propTypes = {
  title: PropTypes.string.isRequired,
  todayStats: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  monthlyStats: PropTypes.object,
};

StatsCard.defaultProps = {
  monthlyStats: {},
};

export default StatsCard;
